/**
 * Picks up data the server-rendered shell already has, so the SPA doesn't need a network round-trip:
 *  - window.__STORE__.builder / .by_ids : the builder sections and the products they list, inlined
 *    in the HTML (see _seo_inline_builder in catalog_backend/main.py)
 *  - window.__EARLY__ : requests the shell started before this bundle was even downloaded
 *    (see _SEO_EARLY_FETCH_JS in catalog_backend/main.py)
 *
 * Every helper is one-shot and returns null whenever anything is off (nothing inlined, a different
 * URL, a failed/non-OK response), so the caller simply does its normal fetch in that case.
 */
function earlyStore() {
  try {
    return typeof window !== "undefined" && window.__EARLY__ && typeof window.__EARLY__ === "object"
      ? window.__EARLY__
      : null;
  } catch {
    return null;
  }
}

function inlineSeed() {
  try {
    const S = typeof window !== "undefined" ? window.__STORE__ : null;
    return S && typeof S === "object" ? S : null;
  } catch {
    return null;
  }
}

function jsonResponse(data) {
  return new Response(JSON.stringify(data), {
    status: 200,
    headers: { "Content-Type": "application/json" },
  });
}

/** kind: "catalog" | "builder". Returns an unread, OK Response, or null. */
export async function takeEarlyResponse(kind, url) {
  try {
    if (kind === "builder") {
      const S = inlineSeed();
      if (S && S.builder && S.ident && String(url).endsWith(`/builder/catalog/public/${encodeURIComponent(S.ident)}`)) {
        const data = S.builder;
        S.builder = null; // one-shot: later reloads (e.g. retries) go to the network
        return jsonResponse(data);
      }
    }
    const E = earlyStore();
    if (!E || !E[kind] || E[`${kind}Url`] !== url) return null;
    const pending = E[kind];
    E[kind] = null;
    return (await pending) || null;
  } catch {
    return null;
  }
}

/** The products-by-ids response, only if it was requested for every one of these ids (it may contain more). */
export async function takeEarlyProductsByIds(ids) {
  try {
    const S = inlineSeed();
    if (S && S.by_ids && Array.isArray(S.by_ids.ids) && Array.isArray(S.by_ids.products)) {
      const inl = S.by_ids;
      S.by_ids = null;
      const have = new Set(inl.ids.map(String));
      if ([...ids].every((id) => have.has(String(id)))) return jsonResponse({ products: inl.products });
    }
    const E = earlyStore();
    if (!E || !E.byIds) return null;
    const pending = E.byIds;
    E.byIds = null;
    const got = await pending;
    if (!got || !got.res || !Array.isArray(got.ids)) return null;
    const have = new Set(got.ids.map(String));
    return [...ids].every((id) => have.has(String(id))) ? got.res : null;
  } catch {
    return null;
  }
}
